import { render, staticRenderFns } from "./BuildingBulkCustomerUpdater.vue?vue&type=template&id=38fb7a7a"
import script from "./BuildingBulkCustomerUpdater.vue?vue&type=script&lang=ts"
export * from "./BuildingBulkCustomerUpdater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports